// GENERATED from backend/services/billMemory/core — do not edit; run backend/scripts/sync-bill-memory-core.js
/**
 * Phone numbers as vendor clues (design §9, D3 refined after Tiger Lilly's real bills):
 *   junk        — a placeholder pattern (9000000000, 1234567890) or a number on 3+ vendors;
 *   same_vendor — one number on two entries with similar names ("Taj" / "Taj chicken");
 *   ambiguous   — one number on two entries with different names (Chawla / Empire);
 *   unique      — exactly one vendor;  unknown — no vendor has it.
 * Only unique and same_vendor ever make a vendor certain. Pure.
 */

function normalizePhone(s) {
  if (s == null) return null;
  let d = String(s).replace(/\D/g, '');
  if (d.length === 12 && d.startsWith('91')) d = d.slice(2);
  return /^[6-9]\d{9}$/.test(d) ? d : null;
}

function isPatternJunk(p) {
  const d = String(p || '');
  if (/(\d)\1{6,}/.test(d)) return true;
  let up = 1;
  let down = 1;
  for (let i = 1; i < d.length; i++) {
    const step = Number(d[i]) - Number(d[i - 1]);
    up = (step === 1 || (d[i - 1] === '9' && d[i] === '0')) ? up + 1 : 1;
    down = (step === -1 || (d[i - 1] === '0' && d[i] === '9')) ? down + 1 : 1;
    if (up >= 7 || down >= 7) return true;
  }
  return false;
}

const NAME_STOP = new Set(['pvt', 'private', 'ltd', 'limited', 'co', 'and', 'the']);
function nameTokens(name) {
  return String(name || '').toLowerCase().replace(/&/g, ' ').replace(/[^a-z0-9]+/g, ' ')
    .split(' ').filter((t) => t && !NAME_STOP.has(t));
}

/** "Taj" ~ "Taj chicken", "De fr" ~ "DE FRESH": each word of the shorter name starts the word at the same place in the longer. */
function similarVendorNames(a, b) {
  let x = nameTokens(a);
  let y = nameTokens(b);
  if (!x.length || !y.length) return false;
  if (x.join(' ').length > y.join(' ').length) [x, y] = [y, x];
  if (x.length > y.length) return false;
  return x.every((t, i) => y[i].startsWith(t));
}

function classifyPhone(p, vendorsWithThisPhone) {
  if (isPatternJunk(p)) return { status: 'junk', vendorIds: [] };
  const byId = new Map();
  for (const v of vendorsWithThisPhone || []) if (v && v.vendor_id != null) byId.set(Number(v.vendor_id), v);
  const vendors = [...byId.values()];
  const ids = [...byId.keys()].sort((m, n) => m - n);
  if (ids.length === 0) return { status: 'unknown', vendorIds: [] };
  if (ids.length === 1) return { status: 'unique', vendorIds: ids };
  if (ids.length >= 3) return { status: 'junk', vendorIds: [] };
  return similarVendorNames(vendors[0].name, vendors[1].name)
    ? { status: 'same_vendor', vendorIds: ids }
    : { status: 'ambiguous', vendorIds: ids };
}

export { normalizePhone, isPatternJunk, similarVendorNames, classifyPhone };
